import React, {useEffect, useState} from 'react'
import {connect} from "react-redux"
import {onAddListTab, onAddTab, onChangeActiveTab, onChangeSortAgainTab, onRemoveTab} from "../../../store/action"
import {CloseOutlined} from '@ant-design/icons'
import {tabComponent} from "../Contants"
import {getLocalData} from "../../../services/StorageServices"

import ListContactPage from "../../manager-contact/components/ListContactPage"
import UserPage from "../../user-manager/components/UserPage"
import SettingTenantPage from "../../setting-tenant/components/SettingTenantPage"
import SettingTenantDealerPage from "../../setting-tenant-agency/components/SettingTenantDealerPage"
import CustomersContainer from "../../customers/components/CustomersContainer"
import CustomerDetailContainer from "../../customer-detail/components/CustomerDetailContainer"
import CustomerHubDetailContainer from "../../customer-hub-detail/components/CustomerHubDetailContainer"
import CustomersHubContainer from "../../customers-hub/components/CustomersHubContainer";
import PhoneNumberHubContainer from "../../phone-number-hub/components/PhoneNumberHubContainer";

const listComponent = [
    {
        id: 'contactPage',
        panelComponent: <ListContactPage/>
    },
    {
        id: 'settingUserPage',
        panelComponent: <UserPage/>
    },
    {
        id: 'settingTenantPage',
        panelComponent: <SettingTenantPage/>
    },
    {
        id: 'settingTenantDealerPage',
        panelComponent: <SettingTenantDealerPage/>
    },
    {
        id: 'customers',
        panelComponent: <CustomersContainer/>
    },
    {
        id: 'customersHub',
        panelComponent: <CustomersHubContainer/>
    },
    {
        id: 'phoneNumberHub',
        panelComponent: <PhoneNumberHubContainer/>
    },
    {
        id: 'customerDetail',
        panelComponent: <CustomerDetailContainer/>
    },
    {
        id: 'customerHubDetail',
        panelComponent: <CustomerHubDetailContainer/>
    }
]

function TabLayout(props) {
    const {
        type,
        tabsNotChangeSort,
        tabs,
        tabActive,
        onRemoveTab,
        onChangeActiveTab,
        onAddListTab,
        onChangeSortAgainTab
    } = props
    const [showToggleTab, setShowToggleTab] = useState(false)
    const listTabs = getLocalData('tabs')
    // const listTabActive = getLocalData('tabActive')

    const _onCheckString = (string) => {
        const arrSplit = string.split('_')

        if (arrSplit.length > 1) {
            return arrSplit[0]
        }

        return string
    }

    const _getComponent = (type) => {
        switch (type) {
            case 'contact':
                return <ListContactPage/>
            case 'settingUser':
                return <UserPage/>
            case 'settingTenant':
                return <SettingTenantPage/>
            case 'settingTenantDealer':
                return <SettingTenantDealerPage/>
            case 'customers':
                return <CustomersContainer/>
            case 'customersHub':
                return <CustomersHubContainer/>
            case 'phoneNumberHub':
                return <PhoneNumberHubContainer/>
            default:
                return null
        }
    }

    const _handleChangeTabActive = (id) => {
        onChangeActiveTab({id})
    }

    const getListTab = () => {
        const listComponentContent = []
        // eslint-disable-next-line array-callback-return
        tabsNotChangeSort.map(item => listComponent.find(component => {
                if (_onCheckString(item.id) === component.id) {
                    listComponentContent.push({
                        id: item.id,
                        component: component.id === 'customerDetail' ?
                            <CustomerDetailContainer idCustomer={item.idProp}/> : (component.id === 'customerHubDetail' ?
                                <CustomerHubDetailContainer idCustomer={item.idProp}/> : _getComponent(type))
                    })
                }
            })
        )

        return listComponentContent
    }

    const onChangeSortTab = (value, index2) => {
        onChangeSortAgainTab({index2})
        onChangeActiveTab({id: value})
    }

    const _onRemoveTab = value => {
        onChangeActiveTab({id: tabComponent.find(item => item.type === type).id})
        onRemoveTab(value)

        const element = document.getElementById(value);
        element.remove();
    }

    const _showToggleTab = () => {
        setShowToggleTab(!showToggleTab)
    }

    const _closeToggleTable = () => {
        setShowToggleTab(false)
    }

    const _setupAgainTabs = () => {
        if (listTabs && listTabs.length > 0) {
            onAddListTab([{
                id: tabComponent.find(item => item.type === type).id,
                title: tabComponent.find(item => item.type === type).title,
                idProp: null,
                icon: tabComponent.find(item => item.type === type).icon
            }, ...listTabs.slice(1)])
        } else {
            onAddListTab([{
                id: tabComponent.find(item => item.type === type).id,
                title: tabComponent.find(item => item.type === type).title,
                idProp: null,
                icon: tabComponent.find(item => item.type === type).icon
            }]);
        }
    }

    const _renderComponent = () => {
        return getListTab().map((item, index) => {
            return <div key={index} className={`content-tab`} id={item.id}>
                {item.component}
            </div>
        })
    }

    useEffect(() => {
        _setupAgainTabs()
        onChangeActiveTab({id: tabComponent.find(item => item.type === type).id})
        // eslint-disable-next-line
    }, [type])

    useEffect(() => {
        const elements = document.querySelectorAll('.content-tab')

        elements.forEach((element) => {
            element.classList.remove('active');
        })

        const elementActive = document.getElementById(tabActive.id)
        if (elementActive) elementActive.classList.add('active')
        // eslint-disable-next-line
    }, [tabActive.id])

    return (<>
        <div className="tab-heading-page">
            {tabs.length <= 6 ? (<ul>
                {tabs.map((item, index) => (
                    <li key={index} className={`${item.id} ${item.id === tabActive.id ? 'active' : ''}`}>
                        <span className="item" onClick={() => _handleChangeTabActive(item.id)}><span
                            className="material-icons">{item.icon}</span>{item.title}</span>
                        {tabComponent.filter(tab => tab.id === item.id).length === 0 && (
                            <span className="closeTab" onClick={() => _onRemoveTab(item.id)}><CloseOutlined/></span>)}
                    </li>))}
            </ul>) : (<ul className="have-toggle-tab">
                {tabs.slice(0, 6).map((item, index) => (
                    <li key={index} className={`${item.id} ${item.id === tabActive.id ? 'active' : ''}`}>
                        <span className="item" onClick={() => _handleChangeTabActive(item.id)}><span
                            className="material-icons">{item.icon}</span>{item.title}</span>
                        {tabComponent.filter(tab => tab.id === item.id).length === 0 && (
                            <span className="closeTab" onClick={() => _onRemoveTab(item.id)}><CloseOutlined/></span>)}
                    </li>))}
                <div className="custom-select" onClick={_showToggleTab}>
                    <span>More <span className="number">{tabs.slice(6).length}</span></span>
                    <ul className={showToggleTab ? 'open' : ''}>
                        {tabs.slice(6).map((item, index) => (
                            <li key={index} className={`${item.id} ${item.id === tabActive.id ? 'active' : ''}`}>
                                {tabs.slice(0, 6).filter(i => i.id === item.id).length > 0 && <i className="ti-check"/>}
                                <span className="item"
                                      onClick={() => onChangeSortTab(item.id, index + 6)}><span
                                    className="material-icons">{item.icon}</span>{item.title}</span>
                                {item.id !== 'leadPage' && (<span onClick={() => _onRemoveTab(item.id)}>
                                <CloseOutlined/>
                                </span>)}
                            </li>))}
                    </ul>
                    {showToggleTab && <div className="background" onClick={_closeToggleTable}/>}
                </div>
            </ul>)}
        </div>
        <div className="tab-content-page">
            {_renderComponent()}
        </div>
    </>)
}

const mapStateToProps = (state) => {
    return {
        tabs: state.tabsReducer.tabs,
        tabActive: state.tabsReducer.tabActive,
        tabsNotChangeSort: state.tabsReducer.tabsNotChangeSort
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        onAddTab: (data) => dispatch(onAddTab(data)),
        onRemoveTab: (data) => dispatch(onRemoveTab(data)),
        onChangeActiveTab: (data) => dispatch(onChangeActiveTab(data)),
        onAddListTab: (data) => dispatch(onAddListTab(data)),
        onChangeSortAgainTab: (data) => dispatch(onChangeSortAgainTab(data)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(TabLayout)
